<template>
    <Page route-path="/download.html">
        <div class="body">
            <div class="background">
                <img v-if="isNormal" class="background-image" src="@/assets/download/download_banner.png" />
                <img v-else class="background-image" src="@/assets/download/download_banner_mobile.png" />
            </div>
            <div class="content">
                <div class="caption">
                    <div class="title">{{ header_indo.title }}</div>
                    <div class="des">{{ header_indo.description }}</div>
                </div>
                <div class="download-box">
                    <div class="table">
                        <div class="header-row border">
                            <div class="column" v-for="(item, index) of table_column" :key="index"
                                :style="'width:' + item.width">
                                <div class="value">{{ item.title }}</div>
                            </div>
                        </div>
                        <div class="body-row border" v-for="(item, index) of table_data" :key="index">
                            <div class="column" v-for="(item2, index2) of table_column" :key="index2"
                                :style="'width:' + item2.width">
                                <div class="action" :class="'cell-' + item2.key" v-if="item2.key == 'action'">
                                    <a @click.stop :href="'https://lowcode.linkgie.com/download/resource/' + item.id" target="_blank">
                                        <el-button type="primary" style="background: #2E64F3;">下载</el-button>
                                    </a>
                                </div>
                                <div class="value" :class="'cell-' + item2.key" v-else-if="item2.key == 'size'">
                                    {{ toBytesUnit(item[item2.key]) }}
                                </div>
                                <div class="value" :class="'cell-' + item2.key" v-else>
                                    {{ item[item2.key] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </Page>
</template>
<script>
import {LowcodeCenter} from "@/utils/request";
// import { right } from "@popperjs/core";
import { ResponsiveBase } from "../../layout/reponsive-base";

const CONVERT_TO_SIZE_UNIT = function(sizeInBytes) {
    if (isNaN(sizeInBytes)) {
        return '';
    }
    let units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let exp = Math.floor(Math.log(sizeInBytes)/Math.log(2));
    if (exp < 1) {
        exp = 0;
    }
    let i = Math.floor(exp / 10);
    sizeInBytes = sizeInBytes / Math.pow(2, 10 * i);

    if (sizeInBytes.toString().length > sizeInBytes.toFixed(2).toString().length) {
        sizeInBytes = sizeInBytes.toFixed(2);
    }
    return sizeInBytes + ' ' + units[i];
};


export default {
    name: "Download",
    mixins: [ResponsiveBase],
    data() {
        return {
            header_indo: {
                title: '下载中心',
                description: '开发包、工具和其它资源',
            },
            table_column: [
                {
                    title: '#',
                    key: 'number',
                    width: '80px',
                },
                {
                    title: '名称',
                    key: 'name',
                    width: '160px',
                },
                {
                    title: '版本',
                    key: 'version',
                    width: '230px',
                },
                {
                    title: '发布时间',
                    key: 'publishedTime',
                    width: '180px',
                },
                {
                    title: '大小',
                    key: 'size',
                    width: '150px',
                },
                {
                    title: 'SHA256',
                    key: 'contentHash',
                    width: '280px',
                },
                {
                    title: '说明',
                    key: 'description',
                    width: '25%',
                },
                {
                    title: '操作',
                    key: 'action',
                    width: '6rem',
                },
            ],
            table_data: [
                // {   
                //     number: '02',
                //     id:'',
                //     version: '星河1.0',
                //     contentHash: 'SHA128',
                //     description: '这里是版本说明这里是版本说明版本说明',
                //     createdTime: '2023-06-13',
                //       publishedTime
                //     downloadToken:'',
                // },
            ],
            dialogVisible: false,
            labelPosition: 'right',
            formLabelAlign: {
                account: '',
                passwork: '',
            },
            token: 'obLyFPdHQTUJBbdWwxDS7quBWp8q6eygfjFYtsZKQZ12R9k',
        };
    },
    created() { },
    inject: ["pageIndicator"],
    computed: {},

    mounted() {
        this.downloadList();
    },

    methods: {
        downloadList() {
            LowcodeCenter.request({
                url: `/api/ffs/secure/${this.token}/metadata/files/published`,
                method: "get",
            })
                .then((resp) => {
                    console.info("结果！ -- ", resp);
                    this.table_data = resp.data;
                    this.table_data.forEach((value, key) => {
                        value.number = key + 1;

                        if (value.name == 'gdk' || value.name == 'gre') {
                            if (value.name == 'gdk' && !value.description) {
                                value.description = "星河低代码开发工具包";
                            }
                            value.name = value.name.toUpperCase();
                        }
                        value.publishedTime = value.publishedTime ?  this.timestampToTime(value.publishedTime) : '';
                        value.version = value.attributes.version;
                    })
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        submitForm() {
            this.$refs['formRef'].validate((valid) => {
                if (valid) {
                    this.login();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        login() {

            //let params = new URLSearchParams();
            let params = new FormData();
            params.append('username', this.formLabelAlign.account);
            params.append('password', this.formLabelAlign.passwork);
            LowcodeCenter.request({
                url: "/api/login",
                method: "post",
                data: params,
                // headers: {
                //     "Content-Type": "application/x-www-form-urlencoded",
                //     "No-Redirect": "true",
                // },
            })
                .then((resp) => {
                    console.info("结果！ -- ", resp);

                })
                .catch((e) => {
                    console.log(e);
                });

        },
        timestampToTime(timestamp) {
            timestamp = timestamp ? timestamp : null;
            let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
            // let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            // let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            // let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        },

        toBytesUnit(bytes){
            return CONVERT_TO_SIZE_UNIT(bytes);
        }
    },
};
</script>
<style lang="less" scoped>
.body {
    padding-top: 65px;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 977px;

    @media screen and (max-width: 850px) {
        min-height: auto;
    }
}

.background {
    width: 100%;
    height: 496px;
    position: absolute;
    z-index: -10;

    @media screen and (max-width: 850px) {
        height: 375px;
        top: 15px;
    }

    .background-image {
        height: 100%;
        width: 100%;
        min-width: 1280px;
        object-fit: cover;

        @media screen and (max-width: 850px) {
            min-width: 320px;

        }
    }
}

.content {
    max-width: 1280px;
    width: 100%;
    margin: 0px auto;
    margin-top: 113px;
    margin-bottom: 80px;

    @media screen and (max-width: 850px) {
        margin-top: 60px;
        margin-bottom: 40px;
    }

    .caption {
        text-align: center;

        @media screen and (max-width: 850px) {
            text-align: start;
            padding-left: 20px;
        }

        .title {
            height: 48px;
            font-size: 48px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #040420;
            line-height: 48px;

            @media screen and (max-width: 850px) {
                height: 24px;
                font-size: 24px;
                line-height: 24px;
            }
        }

        .des {
            height: 20px;
            font-size: 20px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #7E8FA0;
            line-height: 20px;
            margin-top: 35px;

            @media screen and (max-width: 850px) {
                font-size: 14px;
                line-height: 14px;
                margin-top: 16px;
                font-weight: 500;
                color: #040420;
            }
        }
    }

    .download-box {
        margin-top: 132px;

        @media screen and (max-width: 850px) {
            margin-top: 197px;
        }

        .title {
            // height: 28px;
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #475669;
            // line-height: 2px;

            @media screen and (max-width: 850px) {
                height: 18px;
                font-size: 18px;
                line-height: 18px;
                text-align: center;
            }
        }

        .table {
            margin-top: 40px;
            background-color: #ffffff;

            @media screen and (max-width: 850px) {
                margin-top: 24px;
                padding: 0px 20px;

                .column:first-child {
                    display: none !important;
                }

                .column:last-child {
                    display: none !important;
                }

                .column:nth-of-type(2) {
                    width: 18% !important;
                }

                .column:nth-of-type(3) {
                    width: 20% !important;
                }

                .column:nth-of-type(5) {
                    width: 25% !important;
                }
            }

            .header-row {
                display: flex;
                width: 100%;
                height: 56px;
                background: #F5F6F8;

                @media screen and (max-width: 850px) {
                    height: 40px;
                }

                .column {
                    display: flex;
                    align-items: center;
                    padding: 10px 24px;

                    @media screen and (max-width: 850px) {
                        padding: 0px 12px;
                    }

                    .value {
                        font-size: 16px;
                        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                        font-weight: 500;
                        color: #475669;
                        line-height: 20px;

                        @media screen and (max-width: 850px) {
                            font-size: 16px;
                            line-height: 16px;
                        }
                    }
                }
            }

            .body-row {
                display: flex;
                width: 100%;
                // height: 56px;

                @media screen and (max-width: 850px) {
                    height: auto;
                }

                .column {
                    display: flex;
                    align-items: center;
                    padding: 10px 24px;

                    @media screen and (max-width: 850px) {
                        padding: 0px 12px;
                    }

                    .value {
                        font-size: 16px;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #727272;
                        line-height: 22px;

                        @media screen and (max-width: 850px) {
                            font-size: 14px;
                            height: auto;
                            padding: 5px 0px;
                        }
                    }

                    .action {
                        height: 100%;
                        display: flex;
                        align-items: center;
                    }
                }
            }

            .body-row:hover {
                background: #F5F6F8;
            }

            .border {
                border-bottom: 1px solid #E0E5EE;
            }

        }
    }
}

//登录表单
.dialog-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.tip {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    .tip-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        width: 18px;
        height: 18px;
        background: #FEA751;
        border-radius: 50%;
    }

    .tip-text {
        margin-left: 12px;
        height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 18px;
    }
}

.form-title {
    text-align: center;
    margin-top: 36px;
    height: 24px;
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
}

.form {
    display: flex;
    justify-content: center;
}

.el-form {
    margin-top: 56px;
    width: 380px;
}

.el-form-item {
    justify-content: center;
}

:deep(.el-form-item .el-form-item__content) {
    justify-content: center;
}

.forgot {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #2E64F3;
    line-height: 14px;
}

.submit {
    width: 100%;
}

.foot {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    line-height: 14px;
}


.cell-contentHash {
    font-size: 13px !important;
}

.cell-name {
    font-weight: bolder !important;
}


</style>
